<template>
	<Layout :pageTitle="'Ingresar'" :hideNavbar="true" :hideFooter="true">
		<div class="container">
			<div class="card">
				<div class="card-body">
					<router-link tag="a" to="/">
						<img src="https://cobraticket.uy/logo.svg" alt="" class="logo" />
					</router-link>
					<div class="form-box" v-if="!sended">
						<h3 class="mt-3">{{ $t("title") }}</h3>
						<p>{{ $t("subtitle") }}</p>

						<FormulateForm v-model="form" ref="form" class="p-2" @submit="submit">
							<FormulateInput
								:label="$t('password')"
								type="password"
								name="password"
								:validation-name="$t('password')"
								validation="required"
							/>
							<FormulateInput
								:label="$t('passwordConfirm')"
								type="password"
								name="password_confirm"
								validation="required|confirm"
								:validation-name="$t('passwordConfirm')"
							/>

							<div class="alert text-danger" v-if="error">
								{{ $t("loginError") }}
							</div>

							<div class="form-group text-right mb-0">
								<button class="btn btn-primary btn-block" type="submit" :disabled="loading">
									<span v-if="loading">{{ $t("sending") }}...</span>
									<span v-if="!loading">{{ $t("button") }}</span>
								</button>
							</div>
						</FormulateForm>
					</div>
					<div class="form-box" v-if="sended">
						<h3 class="mt-3">{{ $t("sended") }}</h3>
						<p>{{ $t("sendedText") }}</p>
						<p>{{ $t("redirectIn", { n: redirectIn }) }}</p>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"

export default {
	name: "PasswordReset",
	components: {
		Layout
	},
	data() {
		return {
			loading: false,
			sended: false,
			error: false,
			form: {
				code: null,
				password: null,
				passwordConfirm: null
			},
			redirectIn: 5
		}
	},
	beforeMount() {
		if (this.$route.params.code) this.form.code = this.$route.params.code
	},
	methods: {
		submit() {
			if (!this.loading) {
				this.loading = true
				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($code: String!, $password: String!, $passwordConfirm: String!) {
								userPasswordReset(code: $code, password: $password, passwordConfirm: $passwordConfirm)
							}
						`,
						variables: {
							code: this.form.code,
							password: this.form.password,
							passwordConfirm: this.form.password_confirm
						}
					})
					.then((data) => {
						this.loading = false
						this.sended = true

						this.countDownTimer()
					})
					.catch(() => {
						this.loading = false
					})
			}
		},
		countDownTimer() {
			if (this.redirectIn > 0) {
				setTimeout(() => {
					this.redirectIn -= 1
					this.countDownTimer()
				}, 1000)
			}
			if (this.redirectIn == 0) {
				this.$router.push("/login")
			}
		}
	},
	i18n: {
		messages: {
			es: {
				title: "Resetear contraseña",
				subtitle: "Ingrese una nueva contraseña",
				password: "Contraseña",
				passwordConfirm: "Confirmar contraseña",
				button: "Resetear mi contraseña",
				sended: "Hecho!",
				sendedText: "Ahora puede ingresar con su nueva contraseña.",
				redirectIn: "Redireccionando al login en {n} segundos"
			},
			en: {
				title: "Reset account password",
				subtitle: "Enter a new password",
				password: "Contraseña",
				passwordConfirm: "Confirmar contraseña",
				button: "Reset my password",
				sended: "Done!",
				sendedText: "Now you can login with your new password.",
				redirectIn: "Redirecting to login in {n} seconds"
			},
			pt: {
				title: "Resetear contraseña",
				subtitle: "Ingrese una nueva contraseña",
				password: "Senha",
				passwordConfirm: "Confirmar senha",
				button: "Resetear mi contraseña",
				sended: "Hecho!",
				sendedText: "Ahora puede ingresar con su nueva contraseña.",
				redirectIn: "Redireccionando al login en {n} segundos"
			}
		}
	}
}
</script>
<style scoped lang="scss">
.container {
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	.card {
		width: 414px;
		text-align: center;
		padding-top: 32px;
		padding-bottom: 32px;

		.card-body {
			width: 100%;
			max-width: 85%;
			padding: 0px;
			margin: auto;

			h3 {
				font-size: 1.4rem;
			}
			.logo {
				width: 200px;
				margin-bottom: 10px;
			}
		}
	}
}
.btn-block {
	width: 100%;
}
</style>
